import { render, staticRenderFns } from "./Infopage.vue?vue&type=template&id=1fe81b42&"
import script from "./Infopage.vue?vue&type=script&lang=js&"
export * from "./Infopage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports